import { useGetRoutes } from '@application/Interfaces/Hooks/useGetRoutes'
import { TradelaneTab } from '@src/Application/Types/ComponentTypes'
import { Nullable } from '@src/Application/Types/Opt'
import { Currency } from '@src/Core/Types/Currency'
import { Continent, GetRoutesParams } from '@src/Infrastructure/Types/GetRoutes'
import { Route } from '@src/Infrastructure/Types/Routes'

export const handleTabChange =
    (setSelectedTab: (selectedTab: string) => void) =>
    (value: string): void => {
        setSelectedTab(value)
    }

export const getQueryParams = (tab: TradelaneTab): GetRoutesParams => {
    const params = {
        numberOfResults: tab.numberOfResults || 10,
        currency: tab.currency as Currency,
    } as GetRoutesParams

    if (tab.originType === 'country' && tab.originCode) {
        params.originCountry = tab.originCode
    }

    if (tab.destinationType === 'country' && tab.destinationCode) {
        params.destinationCountry = tab.destinationCode
    }

    if (tab.originType === 'continent' && tab.originCode) {
        params.originContinent = tab.originCode as Continent
    }

    if (tab.destinationType === 'continent' && tab.destinationCode) {
        params.destinationContinent = tab.destinationCode as Continent
    }

    if (tab.originType === 'port' && tab.originCode) {
        params.originPort = tab.originCode
    }

    if (tab.destinationType === 'port' && tab.destinationCode) {
        params.destinationPort = tab.destinationCode
    }

    return params
}

export const fetchData = async ({
    refetch,
    setRoutes,
    setError,
}: {
    refetch: ReturnType<typeof useGetRoutes>['refetch']
    setRoutes: (routes: Nullable<Route[]>) => void
    setError: (error: boolean) => void
}): Promise<void> => {
    const { data, isError, isLoading } = await refetch()

    if (isError && !isLoading) {
        setError(true)
    }
    if (!isLoading && !isError && data) {
        setRoutes(data?.data)
    }
}
